import { memo, useCallback, useMemo } from "react";
import type { SiteUser } from "@src/features/settings/data/mock-sites";
import { ListRoleSelector } from "./ListRoleSelector";
import { router } from "expo-router";
import { Text, View } from "@src/components";
import { StyleSheet } from "react-native-unistyles";

type SiteUserListProps = {
  users: SiteUser[];
  onRoleChange: (userId: string, role: SiteUser["role"]) => void;
  onPressItem: (userId: string) => void;
};

export const SiteUserList = memo(({ users, onRoleChange, onPressItem }: SiteUserListProps) => {
  const items = useMemo(
    () =>
      users.map((user) => ({
        id: user.id,
        name: user.name,
        role: user.role,
        email: user.email,
        phoneNumber: user.phoneNumber,
      })),
    [users],
  );

  const handleRoleChange = useCallback(
    (userId: string, role: SiteUser["role"]) => {
      onRoleChange(userId, role);
    },
    [onRoleChange],
  );

  if (users.length === 0) {
    return (
      <View style={styles.emptyStateContainer}>
        <Text textStyle="sm/regular" color="textMuted" textAlign="center">
          No users found
        </Text>
      </View>
    );
  }

  return (
    <ListRoleSelector items={items} onRoleChange={handleRoleChange} iconName="chevronRight" onPressItem={onPressItem} />
  );
});

const styles = StyleSheet.create((theme) => ({
  emptyStateContainer: {
    paddingVertical: theme.spacing["5xl"],
  },
}));
